export var ON_GRAY_BG = 'on-gray-bg';
